<template>
  <div
    v-if="innerVisible"
    class="rt-xpc-guide"
  >
    <div
      ref="wrapper"
      class="rt-xpc-guide-wrapper"
      :class="arrowClass"
    >
      <div class="rt-xpc-guide-header">
        <div class="rt-xpc-guide-title">
          {{ title }}
        </div>
        <div class="rt-xpc-guide-close">
          <rt-icon
            type="iconFont"
            :size="16"
            name="rt-base-close-x-lined"
            @click="hide"
          ></rt-icon>
        </div>
      </div>
      <div class="rt-xpc-guide-content">
        {{ content }}
      </div>
      <div class="rt-xpc-guide-footer">
        <div class="rt-xpc-guide-page-number">
          <span class="rt-xpc-guide-page-current">{{ current }} /</span>
          <span class="rt-xpc-guide-page-total">{{ total }}</span>
        </div>
        <div
          v-if="current < total"
          class="rt-xpc-guide-page-btn"
        >
          <rt-icon
            type="iconFont"
            :size="20"
            :class="{ 'rt-icon-disabled': current === 1 }"
            name="rt-base-circle-arrow-left-lined"
            @click="prev"
          ></rt-icon>
          <rt-icon
            type="iconFont"
            :size="20"
            :class="{ 'rt-icon-disabled': current === total }"
            :name="`rt-base-circle-arrow-right-${current === total ? 'lined' : 'filled'}`"
            @click="next"
          ></rt-icon>
        </div>
        <rt-button
          v-else
          size="small"
          type="primary"
          @click="hide"
        >
          {{ $tx('开始体验', 'xpc.guide.startExpericencing') }}
        </rt-button>
      </div>
      <div
        ref="wrapperArrow"
        class="wrapper-arrow"
      >
        <div class="wrapper-arrow-dot"></div>
      </div>
    </div>
    <div
      ref="mask"
      class="rt-xpc-guide-mask"
    >
    </div>
    <div
      ref="maskBorder"
      class="rt-xpc-guide-mask-border"
    ></div>
  </div>
</template>

<script>
import RtIcon from 'vue-xpc/src/components/icon/rtIcon';
import RtButton from 'vue-xpc/src/components/button/rtButton';

export default {
  components: { RtIcon, RtButton },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: [Array]
    },
    callback: Function
  },
  data () {
    return {
      total: 0,
      current: 1,
      title: '',
      content: '',
      target: null,
      innerVisible: false,
      arrowClass: ''
    };
  },
  computed: {
    innerData () {
      if (this.data && this.data.length > 0) {
        return this.data.filter(obj => {
          if (obj && obj.target) {
            const { width, height } = obj.target.getBoundingClientRect();
            return width > 0 && height > 0;
          }
        })
      }
      return [];
    }
  },
  watch: {
    innerData (val) {
      this.current = 1;
      this.total = val ? val.length : 0;
      const item = val[this.current - 1];
      if (item) {
        this.title = item.title;
        this.content = item.content;
        this.target = item.target;
      }
    },
    current (val) {
      const item = this.data[val - 1];
      if (item) {
        this.title = item.title;
        this.content = item.content;
        this.target = item.target;
      }
    },
    visible (val) {
      this.innerVisible = val;
      if (val) {
        this.$nextTick(() => {
          const el = this.target;
          if (el.scrollIntoViewIfNeeded) {
            el.scrollIntoViewIfNeeded();
          } else {
            el.scrollIntoView();
          }
          this.calcWrapperPosition();
        });
      }
    },
    target (el) {
      if (this.innerVisible) {
        this.$nextTick(() => {
          if (el.scrollIntoViewIfNeeded) {
            el.scrollIntoViewIfNeeded();
          } else {
            el.scrollIntoView();
          }
          this.calcWrapperPosition();
        });
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.resize);
  },
  destroyed () {
    window.removeEventListener('resize', this.resize);
  },
  methods: {
    resize () {
      if (this.innerVisible) {
        this.calcWrapperPosition();
      }
    },
    calcWrapperPosition () {
      const connectWidth = 86;
      let direction = 'h';
      const offsetX = 26;
      const wrapper = this.$refs.wrapper;
      const wrapperRect = wrapper.getBoundingClientRect();
      const targetRect = this.target.getBoundingClientRect();
      const bodyRect = document.body.getBoundingClientRect();

      const targetX = targetRect.x + targetRect.width;
      const targetY = targetRect.y + targetRect.height / 2;

      let top = 0; let left = 0;

      if (targetY - wrapperRect.height / 2 < 0) {
        top = targetRect.y + targetRect.height + connectWidth;
        this.arrowClass = 'wrapper-arrow-v-top';
        direction = 'v';
      } else if (targetY + wrapperRect.height / 2 > bodyRect.height) {
        top = targetRect.y - connectWidth - wrapperRect.height + 3;
        this.arrowClass = 'wrapper-arrow-v-bottom';
        direction = 'v';
      } else {
        top = targetY - wrapperRect.height / 2;
        direction = 'h';
      }

      if (direction === 'v') {
        left = targetRect.x + targetRect.width / 2 - offsetX;
        if (left + wrapperRect.width > bodyRect.width) {
          left = targetRect.x + targetRect.width / 2 - wrapperRect.width + offsetX;
        }
      }

      if (direction === 'h') {
        if (targetX + connectWidth + wrapperRect.width > bodyRect.width) {
          left = targetX - targetRect.width - connectWidth - wrapperRect.width;
          this.arrowClass = 'wrapper-arrow-h-right';
        } else {
          left = targetX + connectWidth;
          this.arrowClass = 'wrapper-arrow-h-left';
        }
      }

      left = left < 10 ? 10 : left;
      top = top < 10 ? 10 : top;
      if (direction === 'v') {
        const offsetLeft = targetRect.x + targetRect.width / 2 - left - 4;
        this.$refs.wrapperArrow.style.left = `${offsetLeft}px`;
      } else {
        this.$refs.wrapperArrow.style.left = ``;
      }

      wrapper.style.left = `${left}px`;
      wrapper.style.top = `${top}px`;

      const padding = 8;
      const border = 4;
      let path = `polygon(0 0, 0 ${targetRect.y - padding}px, ${targetRect.x - padding}px ${targetRect.y - padding}px, ${targetRect.x + targetRect.width + padding}px ${targetRect.y - padding}px, ${targetRect.x + targetRect.width + padding}px ${targetRect.y + targetRect.height + padding}px, ${targetRect.x - padding}px ${targetRect.y + targetRect.height + padding}px, ${targetRect.x - padding}px ${targetRect.y - padding}px, 0 ${targetRect.y - padding}px, 0 ${bodyRect.height}px, ${bodyRect.width}px ${bodyRect.height}px, ${bodyRect.width}px 0, 0 0)`;

      this.$refs.mask.style.clipPath = path;

      let maskBorderWidth = targetRect.width + padding * 2;
      let maskBorderHeight = targetRect.height + padding * 2;
      let maskBorderTop = targetRect.y - padding - border;
      let maskBorderLeft = targetRect.x - padding - border;
      if (maskBorderTop < 0) {
        maskBorderHeight += maskBorderTop;
        maskBorderTop = 0;
      } else if (maskBorderTop + maskBorderHeight > bodyRect.height) {
        maskBorderHeight = bodyRect.height - maskBorderTop - border * 2;
      }
      if (maskBorderLeft < 0) {
        maskBorderWidth += maskBorderLeft;
        maskBorderLeft = 0;
      } else if (maskBorderLeft + maskBorderWidth + border * 2 > bodyRect.width) {
        maskBorderWidth = bodyRect.width - maskBorderLeft - border * 2;
      }

      this.$refs.maskBorder.style.width = `${maskBorderWidth}px`;
      this.$refs.maskBorder.style.height = `${maskBorderHeight}px`;
      this.$refs.maskBorder.style.top = `${maskBorderTop}px`;
      this.$refs.maskBorder.style.left = `${maskBorderLeft}px`;
    },
    next () {
      if (this.current < this.total) {
        this.current++;
      }
    },
    prev () {
      if (this.current <= this.total && this.current > 1) {
        this.current--;
      }
    },
    hide () {
      this.innerVisible = false;
      this.$emit('update:visible', false);
      this.$emit('close');

      if (this.callback && typeof this.callback === 'function') {
        this.callback({
          currentIndex: this.current,
          data: this.innerData
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// main.vue?22d6a58a